import { TransferOrderCreatePage } from "@/features/transfer-order/pages/TransferOrderCreatePage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/transfer-order/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["transfer_order.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TransferOrderCreatePage,
});
